module.exports = __webpack_public_path__ + "img/1.39bcc5c4.jpg";